module.exports = __webpack_public_path__ + "img/partner_2.d0f0ef89.png";